<template lang="pug">

  .bag
    .bag-icon(ref="bagIcon")
      svg.base-layer(ref="base" @click="openGallery" preserveAspectRatio="xMinYMid meet" viewBox="0 0 104 106" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink")
        defs

          pattern(id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1")
            use(xlink:href="#image0")
          pattern(id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1")
            use(xlink:href="#image1")
          image(id="image0" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABZCAYAAABLwrgcAAAACXBIWXMAAAsSAAALEgHS3X78AAAA")
          image(id="image1" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABTCAYAAADnR+s9AAAACXBIWXMAAAsSAAALEgHS3X78AAAA")
        g
          path(d="M51.0665 120.144C48.8778 125.192 42.9821 127.553 37.9334 125.364L-7.70441 105.65C-12.7531 103.461 -15.1133 97.5655 -12.9245 92.5168L1.92961 58.043C4.11835 52.9943 10.0141 50.6341 15.0628 52.8229L60.7005 72.5367C65.7492 74.7254 68.1094 80.6212 65.9207 85.6699L51.0665 120.144Z" fill="#E15125")
          path(d="M23.0466 36.1782C22.6793 37.0528 23.2864 38.3024 24.4526 38.7922C25.6189 39.2819 26.9454 38.9816 27.4125 38.1145L30.9177 30.2574C31.2851 29.3827 30.678 28.1332 29.5117 27.6434C28.3455 27.1537 27.0189 27.454 26.5519 28.3211L23.0466 36.1782Z" fill="#E15125")
          path(d="M62.9528 53.4509C62.5855 54.3256 63.1926 55.5752 64.3589 56.0649C65.5251 56.5547 66.8517 56.2543 67.3187 55.3872L70.824 47.5301C71.1913 46.6554 70.5842 45.4059 69.4179 44.9161C68.2517 44.4264 66.9251 44.7268 66.4581 45.5939L62.9528 53.4509Z" fill="#E15125")
          path(d="M72.1046 71.5961C68.8215 79.1692 59.928 82.7056 52.355 79.4225L15.9399 63.7188C8.36686 60.4357 4.83039 51.5423 8.1135 43.9692L8.61083 42.7033C11.8939 35.1302 20.7874 31.5938 28.3604 34.8769L64.7755 50.5805C72.3486 53.8636 75.885 62.7571 72.6019 70.3301L72.1046 71.5961Z" fill="#F2C222")
          path(d="M-20.379 92.9536C-21.351 95.1864 -19.8604 98.0074 -16.9523 99.3315C-14.0443 100.656 -10.8774 99.8933 -9.90551 97.6605L-1.34116 78.6547C-0.369229 76.4219 -1.85982 73.6009 -4.76787 72.2768C-7.67592 70.9527 -10.8428 71.715 -11.8147 73.9478L-20.379 92.9536Z" fill="#F2C222")
          path(d="M-21.4531 92.571C-23.647 100.327 -12.0084 104.22 -8.47165 97.2679C-5.63918 91.6664 -2.03297 85.1207 -0.274618 79.1367C1.88893 71.7795 -9.50474 67.3035 -13.1261 74.0485C-16.1807 79.9341 -18.5752 86.3712 -21.4531 92.571C-22.0578 93.9291 -19.9095 94.694 -19.3049 93.3359C-17.8508 90.0366 -16.297 86.7448 -14.8353 83.3458C-13.8709 81.2127 -12.9066 79.0797 -11.9422 76.9466C-11.6974 76.3635 -11.4222 75.3815 -10.9855 74.9132C-10.8782 74.8211 -10.8554 74.5219 -10.7482 74.4298C-10.266 73.3632 -9.15398 73.2472 -7.41218 74.0815C-4.00046 72.7361 -2.30411 74.1687 -2.31556 78.2796C-2.74982 81.3556 -5.33106 84.9704 -6.64758 87.7788C-7.7268 90.1037 -8.69874 92.3365 -9.77796 94.6614C-10.0228 95.2446 -10.298 96.2265 -10.7347 96.6948C-10.842 96.7869 -10.8648 97.0861 -10.972 97.1782C-11.4542 98.2447 -12.5662 98.3608 -14.308 97.5265C-17.7197 98.8719 -19.4161 97.4393 -19.4046 93.3283C-18.8922 91.8629 -21.0404 91.098 -21.4531 92.571Z" fill="#F2C222")
          path(d="M43.5211 121.777C42.5492 124.01 44.0398 126.831 46.9478 128.155C49.8559 129.479 53.0227 128.717 53.9947 126.484L62.559 107.478C63.5309 105.245 62.0403 102.424 59.1323 101.1C56.2242 99.7759 53.0574 100.538 52.0855 102.771L43.5211 121.777Z" fill="#F2C222")
          path(d="M42.447 121.394C40.2532 129.151 51.8917 133.043 55.4285 126.091C58.261 120.49 61.8672 113.944 63.6255 107.96C65.7891 100.603 54.3954 96.127 50.7741 102.872C47.7119 108.857 45.2176 115.287 42.447 121.394C41.8424 122.753 43.9906 123.518 44.5952 122.159C46.0493 118.86 47.6032 115.568 49.0649 112.169C50.0292 110.036 50.9936 107.903 51.9579 105.77C52.2028 105.187 52.478 104.205 52.9147 103.737C53.022 103.645 53.0447 103.345 53.152 103.253C53.6342 102.187 54.7462 102.071 56.488 102.905C59.8997 101.56 61.5961 102.992 61.5846 107.103C61.1503 110.179 58.5691 113.794 57.2526 116.602C56.1734 118.927 55.2014 121.16 54.1222 123.485C53.8773 124.068 53.6021 125.05 53.1654 125.518C53.0581 125.61 53.0354 125.91 52.9281 126.002C52.4459 127.068 51.334 127.184 49.5922 126.35C46.1804 127.695 44.4841 126.263 44.4955 122.152C45.0004 120.786 42.8522 120.021 42.447 121.394Z" fill="#F2C222")
          path(d="M41.6699 102.582C42.8716 99.965 41.7028 96.8675 39.0788 95.7656L15.2312 84.928C12.6147 83.7263 9.5173 84.8951 8.41536 87.5191L1.53485 102.842C0.333189 105.458 1.50191 108.556 4.12598 109.658L27.9735 120.495C30.59 121.697 33.6874 120.528 34.7894 117.904L41.6699 102.582Z" fill="#F7A41A")
          path(d="M42.744 102.964C44.0593 98.8517 42.0702 95.9928 38.4944 94.2168C34.044 92.0735 29.4787 90.1221 24.921 88.071C21.6216 86.6169 18.0914 84.2426 14.5396 83.4713C10.1901 82.6395 7.94586 85.7785 6.48418 89.1775C3.82841 95.0933 -4.55149 106.391 4.03508 110.854C11.463 114.728 19.681 118.762 27.4989 121.462C32.0869 123.114 34.8992 120.42 36.7054 116.445C38.6493 111.98 40.6929 107.522 42.744 102.964C43.3486 101.606 41.2004 100.841 40.5958 102.199C39.4017 104.716 38.2998 107.34 37.1057 109.857C35.5367 113.348 34.1999 119.063 30.0587 119.45C27.4359 119.652 25.0491 118.067 22.7242 116.988C18.8493 115.189 14.9668 113.49 11.092 111.691C8.95887 110.727 6.4118 109.932 4.40116 108.676C0.0113316 105.735 3.73364 100.301 5.29503 96.9096C6.61156 94.1013 7.5671 90.7641 9.2749 88.0858C12.0013 83.8802 15.9077 86.5839 19.2071 88.038C23.2814 89.8518 27.4478 91.773 31.5221 93.5869C35.0133 95.1558 42.3011 96.9129 40.5958 102.199C40.1906 103.572 42.2391 104.33 42.744 102.964Z" fill="#F7A41A")
          path(d="M39.0788 95.7656L15.2312 84.9279C12.6147 83.7263 9.51731 84.895 8.41537 87.5191L6.60909 91.4936C5.40744 94.1101 6.57616 97.2075 9.20022 98.3095L33.0478 109.147C35.6643 110.349 38.7617 109.18 39.8636 106.556L41.6699 102.581C42.8716 99.965 41.7028 96.8675 39.0788 95.7656Z" fill="#F2C222")
          path(d="M39.4612 94.6916C33.2539 91.9134 26.9544 89.0279 20.747 86.2497C18.5142 85.2777 16.0277 83.6848 13.5425 83.3957C9.55396 83.0927 7.7313 85.9629 6.38448 89.1701C3.12409 96.444 7.64394 98.9937 13.5598 101.649C19.8668 104.435 26.1058 108.118 32.6577 110.321C40.8745 113.051 47.235 99.2937 39.7452 94.9137C38.4944 94.217 37.2537 96.0282 38.5045 96.7249C42.0575 98.8 40.9947 102.229 39.3714 105.115C37.8555 107.908 36.284 108.791 33.1311 108.05C30.6686 107.462 28.09 105.762 25.8572 104.79C22.366 103.221 18.9745 101.66 15.4834 100.091C13.2506 99.1188 10.4043 98.3008 8.63101 96.5615C6.48913 94.393 7.60623 91.5695 8.88487 89.2597C10.4008 86.4665 12.072 85.5906 15.2249 86.3316C17.6874 86.9198 20.1739 88.5128 22.3991 89.5844C27.8315 92.0029 33.2563 94.521 38.6887 96.9395C39.9623 97.3371 40.7196 95.2886 39.4612 94.6916Z" fill="#F2C222")
          path(d="M22.4436 92.5801L15.6027 107.704L21.616 110.424L28.4569 95.2999L22.4436 92.5801Z" fill="#E15125")
          path(d="M22.1033 109.319C20.07 108.362 18.1287 107.512 16.0954 106.556C16.3566 107.077 16.5258 107.491 16.787 108.012C19.0755 102.971 21.3639 97.9299 23.6524 92.8888C23.1311 93.15 22.7171 93.3192 22.1958 93.5805C24.2292 94.5373 26.1704 95.3867 28.2038 96.3435C27.9425 95.8222 27.7734 95.4082 27.5121 94.8869C25.2236 99.928 22.9352 104.969 20.6467 110.01C20.0421 111.368 22.1904 112.133 22.795 110.775C25.0834 105.734 27.3719 100.693 29.6603 95.6519C29.9052 95.0688 29.4521 94.4326 28.9687 94.1953C26.9353 93.2385 24.9941 92.389 22.9607 91.4322C22.3776 91.1874 21.7415 91.6405 21.5041 92.1239C19.2157 97.165 16.9272 102.206 14.6388 107.247C14.3939 107.83 14.847 108.467 15.3304 108.704C17.3638 109.661 19.305 110.51 21.3384 111.467C22.5968 112.064 23.3617 109.916 22.1033 109.319Z" fill="#E15125")
          path(d="M19.1713 99.9568L16.9871 104.786L23.0004 107.506L25.1846 102.677L19.1713 99.9568Z" fill="white")
          path(d="M23.4274 106.411C21.3941 105.454 19.4528 104.604 17.4195 103.648C17.6807 104.169 17.8499 104.583 18.1111 105.104C18.8306 103.554 19.5577 101.905 20.2771 100.355C19.7558 100.616 19.3418 100.785 18.8206 101.046C20.8539 102.003 22.7951 102.853 24.8285 103.809C24.5672 103.288 24.3981 102.874 24.1369 102.353C23.4174 103.903 22.6903 105.552 21.9708 107.102C21.3662 108.46 23.5145 109.225 24.1191 107.867C24.8386 106.317 25.5656 104.668 26.2851 103.118C26.53 102.534 26.0769 101.898 25.5934 101.661C23.5601 100.704 21.6188 99.8548 19.5855 98.898C19.0024 98.6532 18.3662 99.1063 18.1289 99.5897C17.4094 101.14 16.6824 102.789 15.9629 104.339C15.718 104.922 16.1711 105.558 16.6545 105.796C18.6879 106.753 20.6291 107.602 22.6625 108.559C23.9285 109.056 24.6858 107.008 23.4274 106.411Z" fill="white")
          path(d="M69.5659 77.3581L5.57306 49.7368L-1.67901 66.5384L62.3138 94.1597L69.5659 77.3581Z" fill="#E15125")
      svg.photo-layer(ref="bag" preserveAspectRatio="xMinYMid meet" viewBox="0 0 104 106" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink")
        g
          path(ref="photoFront" d="M50.8978 84.047C50.6107 84.3341 50.2279 84.3341 49.9408 84.1427L21.8053 59.4524C21.5182 59.1653 21.5182 58.7825 21.7096 58.4954L57.8838 17.2491C58.1709 16.962 58.5537 16.962 58.8408 17.1534L86.8806 41.748C87.1677 42.0351 87.1677 42.4179 86.9763 42.705L50.8978 84.047Z" fill="none")
          path(d="M44.5725 84.5289C44.2892 84.8122 43.9116 84.8122 43.6283 84.6233L15.8689 60.2631C15.5857 59.9798 15.5857 59.6021 15.7745 59.3189L51.4651 18.624C51.7484 18.3407 52.1261 18.3407 52.4093 18.5296L80.1687 42.8898C80.452 43.1731 80.452 43.5508 80.2632 43.834L44.5725 84.5289Z" fill="none")
          path(ref="photoBack" d="M43.0505 84.5255C42.7634 84.8126 42.3806 84.8126 42.0935 84.6212L13.958 59.9309C13.6709 59.6438 13.6709 59.261 13.8623 58.9739L50.0365 17.7276C50.3236 17.4405 50.7064 17.4405 50.9935 17.6319L79.129 42.3223C79.4161 42.6094 79.4161 42.9922 79.2247 43.2792L43.0505 84.5255Z" fill="none")
      .photos(ref="photos")
      svg.upper-layer(ref="upper" preserveAspectRatio="xMinYMid meet" viewBox="0 0 104 106" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink")
        g
          path(d="M69.5659 77.3581L5.57306 49.7368L-1.67901 66.5384L62.3138 94.1597L69.5659 77.3581Z" fill="#E15125")


    //.photos(ref="photos")

      //img.photo(ref="photo" src="~assets/destinations/photo.png")
    //.bag-copy(@click="openGallery")
      img(src="~assets/ui/bag-copy.png")
    .flash-light(ref="flashLight")





</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3, Circ} from 'gsap'
//import Component from '@/components/Component'

export default {
  name: "Bag",
  props: {
    prop: {
      default: false,
      required: false
    }
  },
  components: {
    //Component
  },
  data() {
    return {
      tmp:[],
      //active: false
    }
  },
  computed:{
    ...mapState('app', ['gallery'])
  },
  methods: {
    ...mapMutations('app', ['openGallery']),
    init() {},
    animate() {},

    animateIntro() {

      let tl = new TimelineMax({ onComplete: () => {
          this.photoInit()
        }})
      this.tl = tl
      let dur = 1

      tl.add('start')
        // .set(
        //   this.$refs.bagIcon,
        //   {
        //     scale: 0
        //     //x: (window.innerWidth-img.width)/2,
        //     //y: (window.innerHeight-img.height)/2
        //   }
        // )
        .to(
          this.$refs.bagIcon,
          1,
          {
            scale: 1,
            ease: Back.easeOut.config(3)
          },
          `start+=0`
        )


    },
    animateOut() {

      let tl = new TimelineMax({ onComplete: () => {

        }})
      this.tl = tl
      let dur = 1

      tl.add('start')
        .to(
          this.$refs.bagIcon,
          0.7,
          {
            scale: 0,
            ease: Back.easeIn.config(3)
          },
          `start+=0`
        )


    },

    // enter(el, done){
    //   //done()
    //   this.animateIntro(done)
    // },


    animateIn(src) {
      //console.log(this.$el.getBoundingClientRect(), this.$el.offsetHeight)
      //console.log(444, this.$refs.btns.childNodes)
      let photoFront = this.$refs.photoFront
      let photoBack = this.$refs.photoBack
      //console.log(photoFront.getScreenCTM(),photoFront.getBoundingClientRect().x, photoFront.getBoundingClientRect().y, photoBack)
      let rect = photoFront.getBBox()
      let cx = rect.x + rect.width/2
      let cy = rect.y + rect.height/2
      let svg = this.$refs.bag
      let cp = svg.createSVGPoint()
      cp.x = cx
      cp.y = cy
      let ctm = svg.getScreenCTM()
      let CP = cp.matrixTransform(ctm)
      //console.log(photoFront, cx, cy, CP, photoFront.getBBox())

      cx = CP.x
      cy = CP.y


      let img = new Image()
      let flashLight = this.$refs.flashLight
      img.src = src
      let container = this.$refs.photos
      let nw = img.naturalWidth
      let nh = img.naturalHeight
      img.style.width = window.innerWidth+'px'
      img.style.height = window.innerWidth*1.52+'px'
      img.style.display = 'block'
      img.style.border = '20px #fff solid'
      img.style.borderRadius = '10px'
      img.style.position = 'absolute'
      //img.style.zIndex = 6
      //img.style.transformOrigin = 'center'
      //img.style.left = window.innerWidth*0.1+'px'
      //img.style.top = window.innerHeight*0.1+'px'
      //console.log(222, nw, nh)
      container.appendChild(img)



      let w = photoFront.getBoundingClientRect().width*0.4
      let W = window.innerWidth*0.8

      let dx = cx - window.innerWidth/2
      let dy = cy - window.innerWidth*1.52/2

      //console.log('bagbagbagbgabgavbagbha!!!!!', dx, dy)

      //img.style.filter = 'brightness(100)'

      if (this.tl1) {
        this.tl1.seek(this.tl1.endTime(), false)
        this.tl1.kill()
        this.tl1 = null

      }


      if (container.childNodes.length === 1){
        let tl = new TimelineMax({ onComplete: () => {
            this.tl = null
          }
        })
        this.tl1 = tl
        tl.add('start')
          .to(
            flashLight,
            0.1,
            {
              opacity: 1,
              ease: Circ.easeIn
            },
            `start+=0`
          )
          .to(
            flashLight,
            0.7,
            {
              opacity: 0,
              ease: Circ.easeOut
            },
            `start+=0.1`
          )
          .to(
            img,
            1,
            {
              scale: w/W*3.8,
              rotationZ: 30,
              rotationX: -60,
              rotationY: 14,
              ease: Power2.easeOut
            },
            `start+=0.2`
          )
          .to(
            img,
            1.5,
            {
              scale: w/W,
              rotationZ: 40,
              rotationX: 0,
              x: dx,
              y: dy,
              ease: Power2.easeInOut
            },
            `start+=0.7`
          )
        return
      }
      if (container.childNodes.length === 2){
        let tl = new TimelineMax({ onComplete: () => {
            this.tl = null
          }
        })
        this.tl1 = tl
        tl.add('start')
          .to(
            flashLight,
            0.1,
            {
              opacity: 1,
              ease: Circ.easeIn
            },
            `start+=0`
          )
          .to(
            flashLight,
            0.7,
            {
              opacity: 0,
              ease: Circ.easeOut
            },
            `start+=0.1`
          )
          .to(
            img,
            1,
            {
              scale: w/W*3.8,
              rotationZ: 30,
              rotationX: -60,
              rotationY: 14,
              ease: Power2.easeOut
            },
            `start+=0.2`
          )
          .to(
            img,
            1.5,
            {
              scale: w/W,
              rotationZ: 40,
              rotationX: 0,
              x: dx,
              y: dy,
              ease: Power2.easeInOut
            },
            `start+=0.7`
          )
          .to(
            container.childNodes[0],
            0.5,
            {
              x: dx-8,
              y: dy-3,
              rotationZ: 35,
              z: -10,
              ease: Power2.easeInOut
            },
            `start+=0.2`
          )
        return
      }

      if (container.childNodes.length === 3){
        let tl = new TimelineMax({ onComplete: () => {
            this.tl = null
            container.removeChild(container.childNodes[0])
          }
        })
        this.tl1 = tl
        tl.add('start')
          .to(
            flashLight,
            0.1,
            {
              opacity: 1,
              ease: Circ.easeIn
            },
            `start+=0`
          )
          .to(
            flashLight,
            0.7,
            {
              opacity: 0,
              ease: Circ.easeOut
            },
            `start+=0.1`
          )
          .to(
            img,
            1,
            {
              scale: w/W*3.8,
              rotationZ: 30,
              rotationX: -60,
              rotationY: 14,
              ease: Power2.easeOut
            },
            `start+=0.2`
          )
          .to(
            img,
            1.5,
            {
              scale: w/W,
              rotationZ: 40,
              rotationX: 0,
              x: dx,
              y: dy,

              ease: Power2.easeInOut
            },
            `start+=0.7`
          )
          .to(
            container.childNodes[1],
            0.5,
            {
              x: dx-8,
              y: dy-3,
              rotationZ: 35,
              z: -10,
              ease: Power2.easeInOut
            },
            `start+=0.4`
          )
      }

    },
    photoInit() {
      let container = this.$refs.photos
      if (container === undefined || container.childNodes.length>0) return
      if (this.gallery.length === 0) return
      //console.log(this.$el.getBoundingClientRect(), this.$el.offsetHeight)
      //console.log(444, this.$refs.btns.childNodes)
      let photoFront = this.$refs.photoFront
      let photoBack = this.$refs.photoBack
      //console.log(photoFront.getScreenCTM(),photoFront.getBoundingClientRect().x, photoFront.getBoundingClientRect().y, photoBack)
      let rect = photoFront.getBBox()
      let cx = rect.x + rect.width/2
      let cy = rect.y + rect.height/2
      let svg = this.$refs.bag
      let cp = svg.createSVGPoint()
      cp.x = cx
      cp.y = cy
      let ctm = svg.getScreenCTM()
      let CP = cp.matrixTransform(ctm)
      //console.log(photoFront, cx, cy, CP, photoFront.getBBox())

      cx = CP.x
      cy = CP.y

      let img = new Image()
      img.src = this.gallery[0][0]


      img.style.width = window.innerWidth+'px'
      img.style.height = window.innerWidth*1.52+'px'
      img.style.display = 'block'
      img.style.border = '20px #fff solid'
      img.style.borderRadius = '10px'
      img.style.position = 'absolute'
      container.appendChild(img)

      let w = photoFront.getBoundingClientRect().width*0.4
      let W = window.innerWidth*0.8
      let dx = cx - window.innerWidth/2
      let dy = cy - window.innerWidth*1.52/2

      let tl = new TimelineMax({ onComplete: () => {
        }
      })
      this.tl1 = tl
      tl.add('start')

      if (this.gallery.length > 1) {
        let img2 = new Image()
        img2.src = this.gallery[1][0]

        img2.style.width = window.innerWidth+'px'
        img2.style.height = window.innerWidth*1.52+'px'
        img2.style.display = 'block'
        img2.style.border = '20px #fff solid'
        img2.style.borderRadius = '10px'
        img2.style.position = 'absolute'
        container.appendChild(img2)

        tl.set(
            img2,
            {
              scale: 0,
              rotationZ: 40,
              rotationX: 0,
              x: dx,
              y: dy,

            },
            `start+=0`
          )
          .set(
            img,
            {
              scale: 0,
              rotationX: 0,
              x: dx-8,
              y: dy-3,
              rotationZ: 35,
              z: -10,

            },
            `start+=0`
          )
          .to(
            img,
            0.5,
            {
              scale: w/W,
            },
            `start+=0`
          )
          .to(
            img2,
            0.5,
            {
              scale: w/W,

            },
            `start+=0`
          )

      } else{
        tl.set(
            img,
            {
              scale: w/W,
              rotationZ: 40,
              rotationX: 0,
              x: dx,
              y: dy,
              ease: Power2.easeInOut
            },
            `start+=0`
          )
          .to(
            img,
            0.5,
            {
              scale: w/W,
            },
            `start+=0`
          )
      }


    },
  },

  mounted() {
    window.Bag = this
    this.init()
    //this.photoInit()
    //this.animate()
    //this.active = true
    //this.animateIn()
  },
  beforeDestroy(){

  },
  watch: {
    gallery(val){
      this.animateIn(val[0][0])
    }
  }


}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .bag
    +full()
    z-index: 190
    pointer-events: none
    //transform-origin: 0% 100%


    //background-color: #2cff8c
    line-height: 0
    //position: relative

    svg
      //background: red
      width: 100%
      display: block
      //height: 1.2rem
      //position: absolute
      //bottom: 0

    //background: red
    .bag-icon
      //position: relative
      //z-index: auto !important
      //z-index: 6 !important
      +full()
      //width: 1.1rem
      //animation-name: zoomin
      transform: scale(0)
      transform-origin: 0% 100%
      //animation-fill-mode: backwards
      //animation-duration: 1s
      //animation-delay: 0.5s
      //animation-timing-function: cubic-bezier(.34,2.4,.71,.94)


    .photos
      top: 0
      left: 0
      width: 100%
      height: 100%
      //background: #3a54a2
      position: absolute
      z-index: 6
      perspective: 1000px
      perspective-origin: 0 100%
      //background: #030F2D


          //transform: rotateZ(-20deg)
    //.photo
      z-index: 6
      width: 0.35rem
      object-fit: cover
      display: block
      position: absolute
      top: 0rem
      left: 0.37rem
      //transform: rotateZ(38deg)
      transform-origin: center !important
      //perspective: 2000
      //transform-style: preserve-3d
    .base-layer
      position: absolute
      width: 1.1rem
      pointer-events: all
      left: 0
      bottom: 0
      z-index: 5
    .upper-layer
      width: 1.1rem
      position: absolute
      z-index: 7
      bottom: 0
      left: 0
    .photo-layer
      position: absolute
      width: 1.1rem
      bottom: 0
      left: 0
    .bag-copy
      pointer-events: all
      position: absolute
      bottom: 0.16rem
      left: 0.9rem
      width: 0.75rem
      img
        width: 100%
        display: block
        object-fit: cover
    .flash-light
      pointer-events: none
      opacity: 0
      background: white
      position: fixed
      top: 0
      left: 0
      right: 0
      bottom: 0
      z-index: 999

  @keyframes zoomin
    0%
      transform: scale3d(0, 0, 0)
    100%
      transform: scale3d(1, 1, 1)

</style>